import Storage from '../services/Storage';
import {
  fetchCall,
  fetchRegistrationCall,
  fetchJsonCall,
  fetcCallImageUpload,
  getNewDealerbyType,
  promiseJsonCall,
} from './ajax';
import { API_CONSTANTS, API_METHODS } from './api-constant';

export const getLoginDetails = (callback, payload) => {
  let url = API_CONSTANTS.LOGIN_DATA;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const forgotPassword = (callback, payload) => {
  let url = API_CONSTANTS.FORGOT_PASSWORD;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const changePassword = (callback, payload) => {
  let url = API_CONSTANTS.CHANGE_PASSWORD;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const checkPasswordToken = (callback, payload) => {
  let url = API_CONSTANTS.CHECK_PASSWORD_TOKEN;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const resetPassword = (callback, payload) => {
  let url = API_CONSTANTS.RESET_PASSWORD;
  return fetchCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const addDealer = (callback, payload) => {
  let url = API_CONSTANTS.ADD_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};
export const addDealerOwner = (callback, payload) => {
  let url = API_CONSTANTS.ADD_DEALER_OWNER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const verifyOtpDealer = (callback, payload) => {
  let url = API_CONSTANTS.VERIFY_OTP_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const sendOtpDealer = (callback, payload) => {
  let url = API_CONSTANTS.SEND_OTP_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const updateCreditLimit = (callback, payload) => {
  let url = API_CONSTANTS.UPDATE_CREDIT_LIMIT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const getDealerById = (callback, payload) => {
  let queryString = `?id=${payload}`;
  let url = API_CONSTANTS.GET_DEALER_BY_ID + `${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getDealer = (callback, payload) => {
  let queryString = `?q=${payload.q}&page=${payload.page}&pagesize=${payload.pagesize}`;
  let url = API_CONSTANTS.GET_DEALER + `${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getCommitment = (callback, payload) => {
  let queryString = `?user_id=${payload.user_id}&page=${payload.page}&pagesize=${payload.pagesize}&year=${payload.year}`;
  let url = API_CONSTANTS.GET_COMMITMENT + `${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getCompetition = (callback, payload) => {
  let queryString = `?user_id=${payload.user_id}&page=${payload.page}&pagesize=${payload.pagesize}&year=${payload.year}`;
  let url = API_CONSTANTS.GET_COMPETITION + `${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const editDealer = (callback, payload) => {
  let url = API_CONSTANTS.EDIT_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};
export const editDealerOwner = (callback, payload) => {
  let url = API_CONSTANTS.EDIT_DEALER_OWNER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const deleteDealer = (callback, payload) => {
  let url = API_CONSTANTS.DELETE_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const deleteDealerOwner = (callback, payload) => {
  let url = API_CONSTANTS.DELETE_DEALER_OWNER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const deleteCompetition = (callback, payload) => {
  let url = API_CONSTANTS.DELETE_COMPETITION;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const deleteCommitment = (callback, payload) => {
  let url = API_CONSTANTS.DELETE_COMITMENT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const getTerritories = (callback, payload) => {
  let queryString = `?id=${Storage.getUserInfoDetail().id}`;
  let url = API_CONSTANTS.GET_TERRITORY + `${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getProducts = (callback, payload) => {
  let url = API_CONSTANTS.GET_PRODUCTS;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getState = (callback, payload) => {
  let url = API_CONSTANTS.GET_STATE;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getUserInfo = (callback, payload) => {
  let url = API_CONSTANTS.GET_USER_INFO;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getStateDistrict = (callback, payload) => {
  let queryString = `?state_id=${payload.state_id}`;
  let url = API_CONSTANTS.GET_STATE_DISTRICT + queryString;
  // return fetchRegistrationCall(
  //   (response) => {
  //     callback(response);
  //   },
  //   url,
  //   API_METHODS.GET,
  // );
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const getStateCities = (callback, payload) => {
  let url = API_CONSTANTS.GET_STATE_CITY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const dealerDocumentUpload = (callback, payload) => {
  // console.log('payload', payload)
  // payload.forEach((value, key) => {
  //   console.log(key + ':Payload Key:', value);
  //   alert("Payload Key: " + key + ", Value: " + value);
  // });
  let url = API_CONSTANTS.DEALER_DOCUMENT_UPLOAD;
  return fetcCallImageUpload(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const editCommitment = (callback, payload) => {
  let url = API_CONSTANTS.EDIT_COMMITMENT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};
export const addCommitment = (callback, payload) => {
  let url = API_CONSTANTS.ADD_COMMITMENT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const addCompetition = (callback, payload) => {
  let url = API_CONSTANTS.ADD_COMPETITION;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const editCompetitionInsights = (callback, payload) => {
  let url = API_CONSTANTS.EDit_COMPETITION;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};
export const approveDealer = (callback, payload) => {
  let url = API_CONSTANTS.APPROVE_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const saveForApprovalDealer = (callback, payload) => {
  let url = API_CONSTANTS.SAVE_FOR_APPROVE_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const modifyDealer = (callback, payload) => {
  let url = API_CONSTANTS.MODIFY_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const rejectDealer = (callback, payload) => {
  let url = API_CONSTANTS.REJECT_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const yearlyKYC = (callback, payload) => {
  let url = API_CONSTANTS.KYC_DUE;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const getStateDistrictCity = (callback, payload) => {
  let url = API_CONSTANTS.GET_STATE_DISTRICT_CITY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// =====================================
export const getdealerCount = (callback, payload) => {
  let { id } = payload;
  let queryString = `?id=${id}`;
  let url = `${API_CONSTANTS.GET_DEALER_COUNT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getMettingCount = (callback, payload) => {
  let { id, date } = payload;
  let queryString = `?id=${id}&date=${date}`;
  let url = `${API_CONSTANTS.GET_MEETING_COUNT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getOrderSummaryCount = (callback, payload) => {
  let { id, date } = payload;
  let queryString = `?id=${id}&date=${date}`;
  let url = `${API_CONSTANTS.GET_ORDER_SUMMARY_COUNT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getdealerEngagement = (callback, payload) => {
  let { id, date } = payload;
  let queryString = `?id=${id}&date=${date}`;
  let url = `${API_CONSTANTS.GET_DEALER_ENGAGEMENT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getdealerActiveInactiveCount = (callback, payload) => {
  let { id } = payload;
  let queryString = `?id=${id}`;
  let url = `${API_CONSTANTS.GET_DEALER_ACTIVE_INACTIVE_COUNT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getStateHeadList = (callback, payload) => {
  let { id } = payload;
  let url = id?`${API_CONSTANTS.GET_STATE_HEAD_LIST}?id=${id}`:`${API_CONSTANTS.GET_STATE_HEAD_LIST}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getNationalHeadList = (callback, payload) => {
  let { id } = payload;
  let url = `${API_CONSTANTS.GET_NATIONAL_HEAD_LIST}?id=${id}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getBusinessHeadList = (callback, payload) => {
  let url = `${API_CONSTANTS.GET_BUSINESS_HEAD_LIST}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getStateOfStateHead = (callback, payload) => {
  let queryString = `?id=${payload.id}`;
  let url = `${API_CONSTANTS.GET_STATE_OF_STATE_HEAD}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getStateHeadTMById = (callback, payload) => {
  let queryString = payload.id?`?id=${payload.id}`:'';
  let url = `${API_CONSTANTS.GET_STATE_HEAD_TM}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getTerritoriesById = (callback, payload) => {
  let queryString = `?id=${payload.id}`;
  let url = `${API_CONSTANTS.GET_TERRITORY}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Approve Print / Generate PDF
export const generatePDF = (callback, id) => {
  let url = `${API_CONSTANTS.GENERATE_PDF}?id=${id}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Meeting Activity - Dealer Meeting History
export const getDealerMeetingHistory = (callback, payload) => {
  let { id } = payload;
  let url = `${API_CONSTANTS.DEALER_MEETING_HISTORY}?id=${id}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getPendingListWithFilterData = (callback, payload) => {
  let url = API_CONSTANTS.GET_PENDING_WITH_LIST_FILTER;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getMeetingWithStatus = (callback, payload) => {
  let {
    q,
    pagesize,
    page,
    type,
    start_date,
    end_date,
    nh,
    sh,
    th,
    state_id,
    territory_id,
    is_download,
  } = payload;
  let queryString = `?${q ? `q=${q}&` : ''
    }pagesize=${pagesize}&page=${page}&type=${type}&start_date=${start_date}&end_date=${end_date}${nh ? `&nh=${nh}` : ''
    }${sh ? `&sh=${sh}` : ''}${th ? `&th=${th}` : ''}${state_id ? `&state_id=${state_id}` : ''
    }${territory_id ? `&territory_id=${territory_id}` : ''
    }&is_download=${is_download}`;
  let url = `${API_CONSTANTS.GET_MEETING_WITH_STATUS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getDealerwithStatus = (callback, payload) => {
  const {
    q,
    pagesize,
    page,
    type,
    start_date,
    end_date,
    pipeline_status,
    nh,
    sh,
    th,
    state_id,
    territory_id,
    is_download,
    adminOnly,
    manageDealer,
    application_upload,
  } = payload;
  let queryString = `?${q ? `q=${q}` : ''
    }&pagesize=${pagesize}&page=${page}&type=${type}&start_date=${start_date}&end_date=${end_date}${pipeline_status ? `&pipeline_status=${pipeline_status}` : ''
    }${nh ? `&nh=${nh}` : ''}${sh ? `&sh=${sh}` : ''}${th ? `&th=${th}` : ''}${state_id ? `&state_id=${state_id}` : ''
    }${territory_id ? `&territory_id=${territory_id}` : ''
    }&is_download=${is_download}&adminOnly=${adminOnly}&manageDealer=${manageDealer}&application_upload=${application_upload}`;
  let url = `${API_CONSTANTS.GET_DEALER_WITH_STATUS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getOrderSummaryCountWithStatus = (callback, payload) => {
  // let queryString = `?date=${payload.date}`
  let {
    q,
    pagesize,
    page,
    start_date,
    end_date,
    nh,
    sh,
    th,
    state_id,
    territory_id,
    product_id,
    is_download,
  } = payload;
  let queryString = `?q=${q}&pagesize=${pagesize}&page=${page}&start_date=${start_date}&end_date=${end_date}${product_id ? `&product_id=${product_id}` : ''
    }${nh ? `&nh=${nh}` : ''}${sh ? `&sh=${sh}` : ''}${th ? `&th=${th}` : ''}${state_id ? `&state_id=${state_id}` : ''
    }${territory_id ? `&territory_id=${territory_id}` : ''
    }&is_download=${is_download}`;
  let url = `${API_CONSTANTS.GET_ORDER_SUMMARY_COUNT_WITH_STATUS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getDealerEngagementWithStatus = (callback, payload) => {
  let {
    q,
    pagesize,
    page,
    type,
    start_date,
    end_date,
    is_download,
    nh,
    sh,
    th,
    state_id,
    territory_id,
  } = payload;
  let queryString = `?${q ? `q=${q}&` : ''
    }pagesize=${pagesize}&page=${page}&type=${type}${nh ? `&nh=${nh}` : ''}${sh ? `&sh=${sh}` : ''
    }${th ? `&th=${th}` : ''}${state_id ? `&state_id=${state_id}` : ''}${territory_id ? `&territory_id=${territory_id}` : ''
    }&start_date=${start_date}&end_date=${end_date}&is_download=${is_download}`;
  let url = `${API_CONSTANTS.GET_DEALER_ENGAGEMENT_WITH_STATUS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getDealerActiveInActiveWithStatus = (callback, payload) => {
  let {
    q,
    pagesize,
    page,
    status,
    nh,
    sh,
    th,
    state_id,
    territory_id,
    is_download,
    iskycrequire,
    is_confirm_cheques=null
  } = payload;
  let queryString = `?q=${q}&pagesize=${pagesize}&page=${page}&status=${status}${nh ? `&nh=${nh}` : ''
    }${sh ? `&sh=${sh}` : ''}${th ? `&th=${th}` : ''}${state_id ? `&state_id=${state_id}` : ''
    }${territory_id ? `&territory_id=${territory_id}` : ''
    }&is_download=${is_download}&iskycrequire=${iskycrequire}`;
    if(is_confirm_cheques !== null && is_confirm_cheques !== undefined){
        queryString = queryString.concat(`&is_confirm_cheques=${is_confirm_cheques}`)
    }
  let url = `${API_CONSTANTS.GET_DEALER_ACTIVE_INACTIVE_WITH_STATUS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getMeetingCountHierarchy = (callback, payload) => {
  const { id, type, date, own, state_id } = payload;
  let queryString = `?id=${id}&type=${type}&date=${date}&own=${own}&state_id=${state_id}`;
  let url = `${API_CONSTANTS.GET_MEETING_COUNT_HIERARCHY}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// New Dealer pipeline / approved / rejected Hierarchy
export const getNewDealerCountHierarchy = (callback, payload) => {
  let { id, type, own, state_id } = payload;
  let queryString = `?id=${id}&type=${type}&own=${own}&state_id=${state_id}`;
  let url = `${API_CONSTANTS.GET_DEALER_COUNT_HIERARCHY}${queryString}`;
  return getNewDealerbyType(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
    payload,
  );
};

export const getDealerEngagementCountHierarchy = (callback, payload) => {
  let { id, type, date, own, state_id } = payload;
  let queryString = `?id=${id}&type=${type}&date=${date}&own=${own}&state_id=${state_id}`;
  let url = `${API_CONSTANTS.GET_DEALER_ENGAGEMENT_COUNT_HIERARCHY}${queryString}`;
  return getNewDealerbyType(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
    payload,
  );
};

export const getDealerActiveInactiveCountHierarchy = (callback, payload) => {
  let { id, own, state_id } = payload;
  let queryString = `?id=${id}&own=${own}&state_id=${state_id}`;
  let url = `${API_CONSTANTS.GET_DEALER_ACTIVE_INACTIVE_COUNT_HIERARCHY}${queryString}`;
  return getNewDealerbyType(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
    payload,
  );
};

export const getOrderSummaryCountHierarchy = (callback, payload) => {
  let { id, date, own, state_id } = payload;
  let queryString = `?id=${id}&date=${date}&own=${own}&state_id=${state_id}`;
  let url = `${API_CONSTANTS.GET_ORDER_SUMMARY_COUNT_HIERARCHY}${queryString}`;
  return getNewDealerbyType(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
    payload,
  );
};

// Performance API
export const getGoal = (callback, payload) => {
  let { query, userId, month, year } = payload;
  let queryString = `?query=${query}&userId=${userId}&month=${month}&year=${year}`;
  let url = `${API_CONSTANTS.GET_GOAL}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const updateGoal = (callback, payload) => {
  let url = API_CONSTANTS.UPDATE_GOAL;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const getPerformanceInsight = (callback, payload) => {
  let { userId, month, year } = payload;
  let queryString = `?userId=${userId}&month=${month}&year=${year}`;
  let url = `${API_CONSTANTS.GET_PERFORMANCE_INSIGHT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getSuccessors = (callback, payload) => {
  let url = `${API_CONSTANTS.GET_SUCCESSORS}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// admin Apis
export const assignDealerCode = (callback, payload) => {
  let url = API_CONSTANTS.ASSIGN_DEALER_CODE;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};
export const riskMeasureTag = (callback, payload) => {
  let url = API_CONSTANTS.RISK_MEASURE_TAG;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};
export const cashCreditRatio = (callback, payload) => {
  let url = API_CONSTANTS.CASH_CREDIT_RATIO;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Sap Excel
export const getDealerSAPDataById = (callback, payload) => {
  let { dealer_id } = payload;
  let queryString = `?dealer_id=${dealer_id}`;
  let url = API_CONSTANTS.GET_DEALER_SAP_DATA + `${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Manage Dealer - Active Inactive Dealer
export const updateActiveInactiveDealer = (callback, payload) => {
  let url = API_CONSTANTS.ACTIVE_INACTIVE_DEALER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Add User
export const addUser = (callback, payload) => {
  let url = API_CONSTANTS.ADD_USER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Update User
export const updateUser = (callback, payload) => {
  let url = API_CONSTANTS.UPDATE_USER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Manage User - Active Inactive User
export const updateActiveInactiveUser = (callback, payload) => {
  let url = API_CONSTANTS.ACTIVE_INACTIVE_USER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Get User List - admin
export const getListUser = (callback, payload) => {
  const { q, page, pagesize, is_export, role_id, is_active } = payload;
  let queryString = `?q=${q}&page=${page}&pagesize=${pagesize}&role_id=${role_id}&is_active=${is_active}&is_export=${is_export}`;
  let url = `${API_CONSTANTS.GET_LIST_USER}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Change TM
export const getTerritoryTM = (callback, payload) => {
  let url = `${API_CONSTANTS.GET_TERRITORY_TM}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Assign Territory
export const assignTerritory = (callback, payload) => {
  let url = API_CONSTANTS.ASSIGN_TERRITORY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - GET Manager
export const getManager = (callback, payload) => {
  let url = `${API_CONSTANTS.GET_MANAGER}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Change Manager
export const changeManager = (callback, payload) => {
  let url = API_CONSTANTS.CHANGE_MANAGER;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - Get all Territories
export const getAllTerritories = (callback, payload) => {
  const { q, page, pagesize, state_id, is_download } = payload;
  let queryString = `?q=${q}&page=${page}&pagesize=${pagesize}&state_id=${state_id}&is_download=${is_download}`;
  let url = `${API_CONSTANTS.GET_ALL_TERRITORIES}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Add Territory
export const addTerritory = (callback, payload) => {
  let url = API_CONSTANTS.ADD_TERRITORY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Get Product List - admin
export const getProductList = (callback, payload) => {
  const { q, page, pagesize, is_export, status } = payload;
  let queryString = `?q=${q}&page=${page}&pagesize=${pagesize}&status=${status}&is_export=${is_export}`;
  let url = `${API_CONSTANTS.GET_LIST_PRODUCTS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Add Product
export const addProduct = (callback, payload) => {
  let url = API_CONSTANTS.ADD_PRODUCT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - Update Product
export const UpdateProduct = (callback, payload) => {
  let url = API_CONSTANTS.UPDATE_PRODUCT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - delete Product
export const deleteProduct = (callback, payload) => {
  const { id } = payload;
  let queryString = `?id=${id}`;
  let url = `${API_CONSTANTS.DELETE_PRODUCT}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Add Product SKU
export const addProductSku = (callback, payload) => {
  let url = API_CONSTANTS.ADD_PRODUCT_SKU;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - Update product Sku
export const updateProductSku = (callback, payload) => {
  let url = API_CONSTANTS.UPDATE_PRODUCT_SKU;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Get Product SKu List - admin
export const getProductSkuList = (callback, payload) => {
  const { product_id } = payload;
  let queryString = `?product_id=${product_id}`;
  let url = `${API_CONSTANTS.GET_LIST_PRODUCT_SKUS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Get Holiday List - admin
export const getHolidayList = (callback, payload) => {
  const { q, page, pagesize, month, year } = payload;
  let queryString = `?q=${q}&page=${page}&pagesize=${pagesize}&month=${month}&year=${year}`;
  let url = `${API_CONSTANTS.GET_HOLIDAYS}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Admin - Add Holiday
export const addHoliday = (callback, payload) => {
  let url = API_CONSTANTS.ADD_HOLIDAY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - Update Holiday
export const updateHoliday = (callback, payload) => {
  let url = API_CONSTANTS.UPDATE_HOLIDAY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

// Admin - delete Holiday
export const deleteHoliday = (callback, payload) => {
  const { id } = payload;
  let queryString = `?id=${id}`;
  let url = `${API_CONSTANTS.DELETE_HOLIDAY}${queryString}`;
  return fetchRegistrationCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Login Report Calls

export const fetchActiveInactiveUsers = (callback, payload) => {
  const { month, year } = payload;
  let queryString = `?month=${month}&year=${year}`;
  let url = `${API_CONSTANTS.USER_ACTIVE_INACTIVE_LOGIN_COUNT}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const fetchActiveInactiveUserListByDate = (callback, payload) => {
  const { date, state_id } = payload;
  let queryString = `?date=${date}`;

  if (state_id) {
    queryString = queryString + `&state_id=${state_id}`;
  }
  let url = `${API_CONSTANTS.USER_ACTIVE_INACTIVE_LIST_DATE_WISE}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};
export const fetchLoginReportMonthWise = (callback, payload) => {
  const { month, year, state_id } = payload;
  let queryString = `?month=${month}&year=${year}`;

  if (state_id) {
    queryString = queryString + `&state_id=${state_id}`;
  } else {
    queryString = queryString + `&state_id=`;
  }

  let url = `${API_CONSTANTS.USER_LOGIN_REPORT_DATE_WISE}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const fetchUserLoginHistoryMonthWise = (callback, payload) => {
  const { id, month, year } = payload;
  let queryString = `?id=${id}&year=${year}&month=${month}`;
  let url = `${API_CONSTANTS.USER_LOGIN_HISTORY_MONTH_WISE}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const fetchUserLoginHistoryDateWise = (callback, payload) => {
  const { id, date } = payload;
  let queryString = `?id=${id}&date=${date}`;
  let url = `${API_CONSTANTS.USER_LOGIN_HISTORY_DATE_WISE}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Survey Add API
export const addSurvey = (callback, payload) => {
  let url = API_CONSTANTS.ADD_SURVEY;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const generateSurveyReportFile = (callback, payload) => {
  const { survey_form_type } = payload;
  let queryString = `?survey_form_type=${survey_form_type}`;
  let url = `${API_CONSTANTS.GENERATE_SURVEY_REPORT}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// Travel Details
export const savePunchInData = (callback, payload) => {
  let url = API_CONSTANTS.PUNCH_IN;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const savePunchOutData = (callback, payload) => {
  let url = API_CONSTANTS.PUNCH_OUT;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const getPunchingData = (callback, payload) => {
  const { start_date, end_date, page, pagesize } = payload;

  let queryString = `?page=${page}&pagesize=${pagesize}`;

  if (payload.is_download) {
    queryString += '&is_download=true';
  } else {
    queryString += '&is_download=false';
  }

  if (payload.start_date) {
    queryString += `&start_date=${start_date}`;
  }

  if (payload.end_date) {
    queryString += `&end_date=${end_date}`;
  }

  if (payload.territory_id) {
    queryString += `&territory_id=${payload.territory_id}`;
  }
  if (payload.tm_id) {
    queryString += `&tm_id=${payload.tm_id}`;
  }
  if (payload.sh_id) {
    queryString += `&sh_id=${payload.sh_id}`;
  }
  if (payload.nh_id) {
    queryString += `&nh_id=${payload.nh_id}`;
  }
  if (payload.state_id) {
    queryString += `&state_id=${payload.state_id}`;
  }

  let url = `${API_CONSTANTS.GET_PUNCHING_DATA}${queryString}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

// CNF Users
export const getCNFCount = (callback) => {
  let url = `${API_CONSTANTS.CNF_GET_ORDER_COUNT}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getCNFOpenOrders = (callback, payload) => {
  const { page, pagesize } = payload;

  let url = `${API_CONSTANTS.CNF_GET_ORDERS}?order_type=open&pagesize=${pagesize}&page=${page}`;

  if (payload.q) {
    url += `&q=${payload.q}`;
  }

  if (payload.territory_id) {
    url += `&territory_id=${payload.territory_id}`;
  }

  if (payload.user_id) {
    url += `&user_id=${payload.user_id}`;
  }

  if (payload.start_date) {
    url += `&start_date=${payload.start_date}`;
  }

  if (payload.end_date) {
    url += `&end_date=${payload.end_date}`;
  }

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const exportCNFOpenOrders = (callback, payload) => {
  const { page, pagesize } = payload;

  let url = `${API_CONSTANTS.CNF_GET_ORDERS}?order_type=open&pagesize=${pagesize}&page=${page}&is_download=true`;

  if (payload.q) {
    url += `&q=${payload.q}`;
  }

  if (payload.territory_id) {
    url += `&territory_id=${payload.territory_id}`;
  }

  if (payload.user_id) {
    url += `&user_id=${payload.user_id}`;
  }

  if (payload.start_date) {
    url += `&start_date=${payload.start_date}`;
  }

  if (payload.end_date) {
    url += `&end_date=${payload.end_date}`;
  }

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getCNFFulfilledOrders = (callback, payload) => {
  const { page, pagesize } = payload;

  let url = `${API_CONSTANTS.CNF_GET_ORDERS}?order_type=fulfilled&pagesize=${pagesize}&page=${page}`;

  if (payload.q) {
    url += `&q=${payload.q}`;
  }

  if (payload.territory_id) {
    url += `&territory_id=${payload.territory_id}`;
  }

  if (payload.user_id) {
    url += `&user_id=${payload.user_id}`;
  }

  if (payload.start_date) {
    url += `&start_date=${payload.start_date}`;
  }

  if (payload.end_date) {
    url += `&end_date=${payload.end_date}`;
  }

  if (payload.start_date || payload.end_date) {
    url += `&filter_by_date=${payload.filter_by_date}`;
  }

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const exportCNFFulfilledOrders = (callback, payload) => {
  const { page, pagesize } = payload;

  let url = `${API_CONSTANTS.CNF_GET_ORDERS}?order_type=fulfilled&pagesize=${pagesize}&page=${page}&is_download=true`;

  if (payload.q) {
    url += `&q=${payload.q}`;
  }

  if (payload.territory_id) {
    url += `&territory_id=${payload.territory_id}`;
  }

  if (payload.user_id) {
    url += `&user_id=${payload.user_id}`;
  }

  if (payload.start_date) {
    url += `&start_date=${payload.start_date}`;
  }
  if (payload.end_date) {
    url += `&end_date=${payload.end_date}`;
  }

  if (payload.start_date || payload.end_date) {
    url += `&filter_by_date=${payload.filter_by_date}`;
  }

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const getCNFTerritoryManagers = (callback) => {
  let url = `${API_CONSTANTS.CNF_TERRITORY_MANAGERS}`;

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.GET,
  );
};

export const CNFBookOrder = (callback, payload) => {
  let url = `${API_CONSTANTS.CNF_BOOK_ORDER}`;

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const CNFBookMultipleOrder = (callback, payload) => {
  let url = `${API_CONSTANTS.CNF_BOOK_MULTIPLE_ORDER}`;

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const CNFAddInvoice = (callback, payload) => {
  let url = `${API_CONSTANTS.CNF_ADD_INVOICE}`;

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};

export const CNFUpdateInvoice = (callback, payload) => {
  let url = `${API_CONSTANTS.CNF_UPDATE_INVOICE}`;

  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload,
  );
};



export const confirmCheque = async (payload) => {
  const url = `${API_CONSTANTS.CNF_CONFIRM_CHEQUE}`;
  return await promiseJsonCall(url, API_METHODS.POST, payload);
};

export const getCreditOutstandingBalanceApi = (callback, payload) => {
  let url = `${API_CONSTANTS.GET_CREDIT_OUTSTANDING_BALANCE}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};

export const getAgeingReportApi = (callback, payload) => {
  let url = `${API_CONSTANTS.GET_AGEING_REPORT}`;
  return fetchJsonCall(
    (response) => {
      callback(response);
    },
    url,
    API_METHODS.POST,
    payload
  );
};